import { render, staticRenderFns } from "./DisplayLists.vue?vue&type=template&id=004e70eb&"
import script from "./DisplayLists.vue?vue&type=script&lang=js&"
export * from "./DisplayLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VLayout,VSpacer})
